(function() {
    'use strict';
    angular
        .module('rms.common')
        .config(configFunc);

    function configFunc($routeProvider, $locationProvider) {
        $routeProvider
            .when('/*', {
                template: '<div layout-generator="layoutGenerator"></div>',
                resolve: {
                    load: function() {
                    }
                }
            });
        $locationProvider.html5Mode(true);
    }
})();